/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaining several Pomodoros back to back to work through a long to-do list without losing track of time.`)
};

const es_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadenar varios Pomodoros seguidos para avanzar en una lista de tareas larga sin perder la noción del tiempo.`)
};

const de_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere Pomodoros hintereinander verketten, um eine lange To-do-Liste abzuarbeiten, ohne den Überblick über die Zeit zu verlieren.`)
};

const nl_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meerdere Pomodoro's achter elkaar schakelen om een lange to-dolijst door te werken zonder de tijd uit het oog te verliezen.`)
};

const fr_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enchaîner plusieurs Pomodoros à la suite pour venir à bout d’une longue liste de tâches sans perdre le fil du temps.`)
};

const it_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concatenare più Pomodori uno dopo l'altro per portare a termine una lunga lista di cose da fare senza perdere la cognizione del tempo.`)
};

const pt_br2_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadear vários Pomodoros seguidos para avançar em uma lista de tarefas longa sem perder a noção do tempo.`)
};

const pt_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadear vários Pomodoros seguidos para avançar numa lista de tarefas longa sem perder a noção do tempo.`)
};

const ja_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数のポモドーロを連続して行い、時間を見失わずに長いタスクリストをこなす。`)
};

const zh_timer_pomodoro_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续进行多个番茄钟，逐项完成较长的待办清单，同时不会失去时间感。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_use2", locale)
	if (locale === "en") return en_timer_pomodoro_use2(inputs)
	if (locale === "es") return es_timer_pomodoro_use2(inputs)
	if (locale === "de") return de_timer_pomodoro_use2(inputs)
	if (locale === "nl") return nl_timer_pomodoro_use2(inputs)
	if (locale === "fr") return fr_timer_pomodoro_use2(inputs)
	if (locale === "it") return it_timer_pomodoro_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_use2(inputs)
	if (locale === "pt") return pt_timer_pomodoro_use2(inputs)
	if (locale === "ja") return ja_timer_pomodoro_use2(inputs)
	return zh_timer_pomodoro_use2(inputs)
};